import { Theme } from "../models/theme";

const breakpoints = ["576px", "768px", "992px", "1300px", "2000px"];
const sizes = [576, 768, 992, 1300, 2000];

export const theme: Theme = {
  breakpoints,
  colors: {
    white: "#ffffff",
    blue: "#0067B2",
    blueDark: "#05054b",
    dark: "#02041F",
    pinkLight: "#EAC4D2",
    pink: "#E491B0",
    hotPink: "#e94282",
    violet: "#9F88BF",
    violetLight: "#B7A8CB",
    melonLight: "#FAE4CF",
    melon: "#E6C5A5",
    salmon: "#f4a89f",
    mintLight: "#DBE8E1",
    mint: "#94C9AC",
    greenLight: "#94C9AC",
    green: "#00A696",
  },
  fontSizes: [
    "1.4rem", // 0
    "1.6rem", // 1
    "1.8rem", // 2
    "2rem", //   3
    "2.3rem", // 4
    "2.4rem", // 5
    "3.2rem", // 6
    "4.2rem", // 7
    "4.8rem", // 8
    "5.6rem", // 9
    "6.2rem", // 10
    "6.4rem", // 11
    "7.2rem", // 12
    "8rem", //   13
    "8.4rem", // 14
    "10.4rem", //15
    "20rem", //  16
    "25rem", //  17
  ],
  sizes,
  shadows: [
    "5px 5px 20px 0 rgba(0, 0, 0, 0.2);",
    "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px",
  ],
  mediaQueries: {
    sm: `@media screen and (min-width: ${sizes[0]}px)`,
    md: `@media screen and (min-width: ${sizes[1]}px)`,
    mdDown: `@media screen and (max-width: ${sizes[1] - 1}px)`,
    lg: `@media screen and (min-width: ${sizes[2]}px)`,
    lgDown: `@media screen and (max-width: ${sizes[2] - 1}px)`,
    xl: `@media screen and (min-width: ${sizes[3]}px)`,
    xxl: `@media screen and (min-width: ${sizes[4]}px)`,
  },
};

theme.breakpoints.xs = "0px";
theme.breakpoints.sm = "576px";
theme.breakpoints.md = "768px";
theme.breakpoints.lg = "992px";
theme.breakpoints.xl = "1300px";
theme.breakpoints.xxl = "1800px";
